import {apiGet} from './AbstractApi';
import {getStore} from '../index';
import {setEmployees, setHasError, setIsLoading} from '../store/reducer/employee';

export const getEmployees = () => {
    getStore().dispatch(setIsLoading(true));
    return apiGet('/api/fleet-statement/employees')
        .then(response => {
            getStore().dispatch(setHasError(false));
            getStore().dispatch(setEmployees(response));
        })
        .catch(error => {
            getStore().dispatch(setHasError(true));
            throw new Error(error.message);
        })
    ;
}
